// extracted by mini-css-extract-plugin
module.exports = {"component":"SwitchButton_component__2iVEx","background":"SwitchButton_background__35rKK","button":"SwitchButton_button__1GErn"};